import { useIntl } from "react-intl";

import { useGetCountries } from "api/queries/common/useGetCountries";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import Input from "components/atoms/Input/Input";

interface useAddressV1FieldsProps {
  viewOnly?: boolean;
}

export default function useAddressV1Fields({ viewOnly }: useAddressV1FieldsProps) {
  const intl = useIntl();

  const { data: countries = [] } = useGetCountries({
    select: (data) => data.filter((country: { label: string }) => country.label !== "USA"),
    refetchOnMount: false,
  });

  const countryLabel = intl.formatMessage({ id: "general.country", defaultMessage: "Country" });
  const cityLabel = intl.formatMessage({ id: "general.city", defaultMessage: "City" });

  const countryField = (
    <Dropdown
      required
      useHookForm
      name="country_code"
      options={countries}
      placeholder={intl.formatMessage({ id: "general.pleaseSelect", defaultMessage: "Please select" })}
      disabled={viewOnly}
    />
  );

  const cityField = (
    <Input
      placeholder={intl.formatMessage({
        id: "settings.payment-locations.cityPlaceholder",
        defaultMessage: "Enter city name",
      })}
      type="text"
      required
      name="city"
      className="rounded-input input-width-md"
      disabled={viewOnly}
    />
  );

  const fields = [
    {
      label: countryLabel,
      children: countryField,
      required: true,
    },
    {
      label: cityLabel,
      children: cityField,
      required: true,
    },
  ];

  return { fields };
}
